/**
 *  Filename ....: req-status.component.ts
 *  Created by ..: ianday
 *  on Date .....: 11/10/23
 **/
import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ServiceRequestsService } from "../../../../services/service-requests.service";
import { Settings } from "../../../../services/settings";
import { ServiceRequest } from "../../../../models/service.request";
import { NoteService } from "../../../../services/note.service";
import { Notes } from "../../../../models/note";
import { RequestStatus } from "../../../../models/request-status";
import { TransactionHistoryService } from "../../../../services/transactionhistory.service";
import { DwUtils } from "../../../../components/utils/dw-utils";
import { ServiceDefService } from "../../../../services/servicedef.service";
import { MessageDefinitionService } from "../../../../services/messages.service";
import { NewMessageHelper } from "../../drawer/mailmessages/newmessage/newmessage-helper";
import { GlobalService } from 'src/app/services/global.service';
import { RecloseDialogComponent } from 'src/app/components/reclose-dialog/reclose-dialog.component';
import { ServiceRequestMembersMap } from 'src/app/models/service-request-members-map';
import { CasesService } from 'src/app/services/cases.service';
import { ServiceRequestMemberHistory } from 'src/app/models/service-request-member-history';

export class DataRecord {
	public id: number;
	public description: string;
	constructor(id: number, desc: string) {
		this.id = id;
		this.description = desc;
	}
}

@Component({
	selector: 'app-req-status',
	templateUrl: './req-status.component.html',
	styleUrls: ['./req-status.component.css']
})

export class RequestStatusComponent implements OnInit {

	public _requestStatusList: any;
	public _serviceRequest: ServiceRequest;

	public totalRequestStatuses: any;
	public masterStatusReasonList: any;
	public statusReasonsList: any;
	public statusIdForReason: number;
	public strErr: string = '';

	public enableSubmit: boolean = false;
	public enableCancel: boolean = true;
	public isStatusStatus: boolean = false;

	public selectedStatusId: any = 0;
	public selectedStatusReasonId: any = 0;
	public selectedStatusDesc: string = '';
	public statusComment: string = '';
	public statusDesc: string = '';
	public records: any;
	requestemebrsMappins: ServiceRequestMembersMap[] = [];
	displayRecloseDlg = false;

	public msgHelper: NewMessageHelper;

	@Output() cancelClicked: EventEmitter<any> = new EventEmitter<any>();
	@Output() submitClicked: EventEmitter<any> = new EventEmitter<any>();

	@Input() set serviceRequest(val: any) {
		this._serviceRequest = val;
	}
	public get serviceRequest(): ServiceRequest {
		return this._serviceRequest;
	}
	@Input() set requestStatusList(val: Array<RequestStatus>) {

		/*
		if (val === undefined)
			return;

		this.records = [];
		this._requestStatusList = new Array();
		this.totalRequestStatuses = val;
		
		for (const rec of val) {

			// skip these since they have their own workflow...
			if ((rec.shortDescription === 'All') || (rec.shortDescription === 'Approved') || (rec.shortDescription === 'Matched') || rec.shortDescription === 'Unmatched') {
				continue;
			}
			if (rec.activeStatus === 'Inactive' || rec.activeStatus === 'Discontinued') {
				continue;
			}
			this.records.push(rec);
			this._requestStatusList.push(new DataRecord(rec.id, rec.shortDescription));
			if (rec.shortDescription === 'Denied') {
				// make a note of the ID (we will use it later for validation etc.)
				this.statusIdForReason = rec.id;
			}
		}
		*/
	}
	public get requestStatusList(): any {
		return this._requestStatusList;
	}

	@HostListener('document:keypress', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent) {
		this.strErr = '';
	}

	@ViewChild('reclosedlg', { static: true }) reclosedlg: RecloseDialogComponent;

	constructor(public serviceRequestsService: ServiceRequestsService,
		private casesService: CasesService,
		private messageService: MessageDefinitionService,
		public serviceDefsService: ServiceDefService,
		public notesService: NoteService,
		public txService: TransactionHistoryService,
		public globalService: GlobalService) {

	}

	ngOnInit() {

	}
	public doInitialize(): void {

		this.selectedStatusId = 0;
		this.selectedStatusDesc = '';
		this.statusComment = '';
		this.statusDesc = '';
		this.strErr = '';

		this.enableSubmit = false;
		this.isStatusStatus = false;
		this.statusReasonsList = [];
	}
	onShowHandler() {
		this.doInitialize();
		this.queryStatuses();
	}


	queryStatuses() {

		this.records = [];
		this._requestStatusList = new Array();
		this.serviceRequestsService.getAllRequestStatuses().subscribe(
			(data) => {
				this.totalRequestStatuses = data;
				for (const rec of data) {

					// skip these since they have their own workflow...
					if ((rec.shortDescription === 'All') || (rec.shortDescription === 'Approved') || (rec.shortDescription === 'Matched') || rec.shortDescription === 'Unmatched') {
						continue;
					}
					if (rec.activeStatus === 'InActive' || rec.activeStatus === 'Discontinued') {
						continue;
					}
					const UnlimitedFilter = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_DENY_SHOW_UNLIMITED', "SHOW")
					const RestrictedFilter = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_DENY_SHOW_RESTRICTED', "SHOW")
					if (!UnlimitedFilter && !RestrictedFilter) {
						continue;
					}
					if (RestrictedFilter && !UnlimitedFilter) {
						if (rec.selectable === 0) {
							continue;
						}
					}
					this.records.push(rec);
					this._requestStatusList.push(new DataRecord(rec.id, rec.shortDescription));
					if (rec.shortDescription === 'Denied') {
						// make a note of the ID (we will use it later for validation etc.)
						this.statusIdForReason = rec.id;
					}
				}

				this.queryStatusReasons();
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Fetching statuses');
			});
	}

	public queryStatusReasons(): void {

		this.serviceRequestsService.getAllActiveStatusReasons().subscribe(
			(data) => {
				this.masterStatusReasonList = [];
				for (const rec of data) {
					if (rec.activeStatus === 'InActive' || rec.activeStatus === 'Discontinued') {
						continue;
					}
					this.masterStatusReasonList.push(rec);
				}
				this.statusReasonsList = [];
				this.loadMembers();
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Fetching status reason codes');
			});
	}
	public loadMembers() {
		/** For clerically reopened requests the live mappings table is empty —
		 *  use the history table instead and treat selected=1 rows as "mapped". **/
		if (this._serviceRequest && this._serviceRequest.clericalOpen === 1) {
			this.casesService.getMemberHistory(this._serviceRequest.id).subscribe(
				(historyRecords: any[]) => {
					this.requestemebrsMappins = historyRecords.filter(h =>
						h.selected === 1 && !ServiceRequestMemberHistory.isContactOnlyAdvocate(h)
					) as any[];
				},
				() => {
					Settings.getInstance().handleError('Error: unable to retrieve member history from the server');
				}
			);
		} else {
			this.casesService.getServiceRequestMemberMappingsByServiceRequestId(this.serviceRequest.id).subscribe(
				(mapped: any[]) => {
					this.requestemebrsMappins = mapped;
				},
				() => {
					Settings.getInstance().handleError('Error: unable to retrieve member mappings from the server');
				}
			);
		}
	}

	doPreSubmitActions() {
		if (this.selectedStatusId === 0) {
			this.strErr = 'Error: Please select a status value';
			this.enableSubmit = true;
			this.enableCancel = true;
			DwUtils.setFocus('statusId');

			return;
		}
		if (this.selectedStatusReasonId === 0) {
			this.strErr = 'Error: Please select a valid reason';
			this.enableSubmit = true;
			this.enableCancel = true;
			DwUtils.setFocus('statusReasonId');
			return;
		}
		
		/** For clerically reopened requests, skip member validation here since members are loaded
		 *  asynchronously from history. The validation will happen during actual submission. **/
		if (this._serviceRequest.clericalOpen === 1) {
			this.openRecloseDialog();
			this.reclosedlg.showRequestRecloseHandler(this._serviceRequest);
		} else {
			/** For normal (non-clerically-reopened) requests, validate members before proceeding **/
			if (this.requestemebrsMappins && this.requestemebrsMappins.length === 0) {
				this.strErr = 'Error: No member associated with this request';
				return;
			}
			this.continueSubmitProcess(null);
		}
	}

	public continueSubmitProcess(payload: any): void {

		this.enableSubmit = false;
		this.enableCancel = false;
		this.strErr = '';
		
		if (payload) {
			this.serviceRequest.newDateCompleted = payload.dateClosed;
			this.serviceRequest.newDateSubmitted = payload.dateSubmitted;
			this.serviceRequest.suppressEmailFlag = payload.supressEmails;
		}
		
		/** Ensure members are loaded before validating (especially for clerically reopened requests) **/
		const validateAndSubmit = () => {
			if (this.requestemebrsMappins && this.requestemebrsMappins.length === 0) {
				this.strErr = 'Error: No member associated with this request';
				this.enableSubmit = true;
				this.enableCancel = true;
				return;
			}
			this.performSubmit();
		};
		
		/** For clerically reopened requests, reload members from history before validating **/
		if (this._serviceRequest && this._serviceRequest.clericalOpen === 1) {
			this.casesService.getMemberHistory(this._serviceRequest.id).subscribe(
				(historyRecords: any[]) => {
					this.requestemebrsMappins = historyRecords.filter(h =>
						h.selected === 1 && !ServiceRequestMemberHistory.isContactOnlyAdvocate(h)
					) as any[];
					validateAndSubmit();
				},
				() => {
					Settings.getInstance().handleError('Error: unable to retrieve member history from the server');
					this.enableSubmit = true;
					this.enableCancel = true;
				}
			);
		} else {
			validateAndSubmit();
		}
	}
	
	private performSubmit(): void {
		const dateSnapshot = (this.serviceRequest.newDateSubmitted || this.serviceRequest.newDateCompleted) ? {
			dateCreated: this.serviceRequest.dateCreated,
			dateCompleted: this.serviceRequest.dateCompleted
		} : null;

		const statusSnapshot = {
			requestStatusId: this.serviceRequest.requestStatusId,
			recordStatus: this.serviceRequest.recordStatus,
			statusReasonId: this.serviceRequest.statusReasonId
		};

		/*** Submission order:
		 * 1. update the service request record (updating record_status, request_status_id, status_reason_id
		 * 2. If there are any comments, move them to the notes section - along with the status selected.
		 * ***/

		/*** set up values ***/
		const requestStat = this.totalRequestStatuses.find(s => s.id === Number(this.selectedStatusId));
		this.statusDesc = requestStat.shortDescription;
		if (this.serviceRequest.requestStatusId != this.selectedStatusId || requestStat.recordStatus == 0) {
			this.serviceRequest.keepOpen = 0;
		}
		this.serviceRequest.requestStatusId = this.selectedStatusId;
		this.serviceRequest.recordStatus = requestStat.recordStatus;
		this.serviceRequest.statusReasonId = this.selectedStatusReasonId;

		this.globalService.openDialog();
		/*** issue update ... ***/
		this.serviceRequestsService.updateRequestsStatus({ 'serviceRequest': this.serviceRequest, 'comment': this.statusComment }).subscribe(
			(result) => {

				/** create a transaction history record **/

				this.txService.createTransactionHistory('ServiceRequests', this.serviceRequest.id, 'Update',
					'Change Status: ' + this.statusDesc);

				this.txService.logServiceRequestStatusChanges(this.serviceRequest.id, statusSnapshot, {
					requestStatusId: result['requestStatusId'],
					recordStatus: result['recordStatus'],
					statusReasonId: result['statusReasonId']
				});

				if (dateSnapshot) {
					this.txService.logServiceRequestDateChanges(this.serviceRequest.id, dateSnapshot, {
						dateCreated: result['dateCreated'],
						dateCompleted: result['dateCompleted']
					});
				}

				// all good. If there are comments, make a note of them.

				if ((this.statusComment.length > 0) || (this.selectedStatusId > 0)) {

					const note = this.createNoteRecord(this.selectedStatusId, this.statusComment, this.statusDesc, this.serviceRequest.serviceRequestDesc);
					this.notesService.createNote(note).subscribe(
						(result1) => {
							this.serviceRequest.agencyId = result['agencyId'];
							this.serviceRequest['agencyName'] = Settings.getInstance().getAgencyName(this.serviceRequest.agencyId);
							this.serviceRequest.requestStatusId = result['requestStatusId'];
							this.serviceRequest.recordStatus = result['recordStatus'];
							this.serviceRequest.dateCompleted = result['dateCompleted'];
							this.serviceRequest.dateCreated = result['dateCreated'];
							this.serviceRequest.clericalOpen = result['clericalOpen'];
							let status = this.getStatusRecordById(this.serviceRequest.requestStatusId);
							if (status) {
								this.serviceRequest.requestStatusDesc = status.shortDescription;
							}
							this.emitSubmitEvent();
						},
						(error) => {
							this.globalService.closeDialog();
							Settings.getInstance().handleError(error, 'Adding a new note');
						});
				}
				else {
					this.serviceRequest.dateCompleted = result['dateCompleted'];
					this.serviceRequest.dateCreated = result['dateCreated'];
					this.serviceRequest.clericalOpen = result['clericalOpen'];
					// throw the 'update success' event.
					this.emitSubmitEvent();
				}
			},
			(error) => {
				this.globalService.closeDialog();
				Settings.getInstance().handleError(error, 'Updating service request.')
			});
	}
	public onCancelClicked(): void {
		this.cancelClicked.emit();
	}
	public emitSubmitEvent(): void {
		this.globalService.closeDialog();
		this.submitClicked.emit(this.serviceRequest);
	}

	public onSelectStatus(val: any): void {

		this.enableSubmit = true;
		this.selectedStatusDesc = this.records.find(s => s.id === val).description;
		this.selectedStatusReasonId = 0;
		this.statusReasonsList = this.masterStatusReasonList.filter(s => s.requestStatusId === val);

		if (val === this.statusIdForReason) {
			this.isStatusStatus = true;
		}
		else {
			this.isStatusStatus = false;
		}
	}
	public createNoteRecord(statusId: number, comments: string, statusDesc: string, requestDesc: string): Notes {

		let note: Notes = new Notes();

		note.foreignKeyId = this.serviceRequest.caseId;
		note.foreignKeyTable = 'Cases';
		note.noteCategory = 'Responses';
		note.dateAdded = DwUtils.returnCurrentDateTime();
		note.userUid = Settings.getInstance().loggedInUser.username;
		note.userFullName = Settings.getInstance().loggedInUser.name;
		note.commentText = "Request: " + requestDesc + '</br>';

		if (statusId > 0) {
			const statusReason = this.masterStatusReasonList.find(s => s.id === this.selectedStatusReasonId);
			note.commentText += 'Status: [ ' + statusDesc + ' - ';

			if (statusReason !== undefined) {
				note.commentText += statusReason.description + ' ]<br/>';
			}
		}

		if (comments.length > 0) {
			note.commentText += comments;
		}

		return note;
	}
	getStatusRecordById(id: number): RequestStatus | undefined {
		return this.totalRequestStatuses.find(record => record.id === id);
	}
	openRecloseDialog() {
		this.displayRecloseDlg = true;
	}
	submitFromRecloseDialog(event) {
		this.displayRecloseDlg = false;
		this.continueSubmitProcess(event);
	}
	cancelFromRecloseDialog(event) {
		this.displayRecloseDlg = false;
	}
}
